import GameRules from "./GameRules"

GameRules.defaultProps = {
  bannerImage: "",
  colors: {
    primary: "#0F1635",
    primaryFont: "#ffffff",
    secondary: "#ffffff",
    secondaryFont: "#0F1635",
  },
  gameMode: "Punkte",
  quizTagline: "Ja -Ja Ding Dong!",
  quizTitle: "Eurovision The Movie",
  rules: [
    "Der Spieler mit der höchsten Punktzahl am Ende gewinnt.",
    "Für richtige Antworten erhält der Spieler Punkte. Je schneller die Antwort, umso mehr Punkte gibt es.",
    "Ist die Antwort falsch, werden die Punkte abgezogen. Auch hier gilt: je schneller die Antwort, desto größer der Punktabzug.",
    "Wird keine Antwort ausgewählt, werden weder Punkte verdient noch abgezogen... spielt strategisch!",
  ],
}

export default GameRules
